import { useLocation } from "react-router-dom";

import OTPForm from "src/components/OTPForm";
import AuthHeading from "src/components/auth/AuthHeading";

const OTPVerification = () => {
	const location = useLocation();
	const { email } = (location.state ?? {}) as { email?: string };

	return (
		<>
			<AuthHeading
				title="Verify your email"
				subtitle={email ? `Enter the code we sent to ${email}.` : "Enter the code that was sent to your email."}
			/>
			{/* OTPForm reads the email from router state itself. */}
			<OTPForm />
		</>
	);
};

export default OTPVerification;
